<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        element-loading-text="努力加载数据中，请耐心等待"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="消息触发类型">
                    <el-radio-group v-model="dialogViewForm.type">
                      <el-radio
                        :label="1"
                        disabled
                      >
                        实时触发
                      </el-radio>
                      <el-radio
                        :label="2"
                        disabled
                      >
                        定时触发
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="业务单据">
                    <el-input
                      v-model="dialogViewForm.businessName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.type === 1"
                  :span="6"
                >
                  <el-form-item label="消息实时触发节点">
                    <el-input
                      v-model="dialogViewForm.nodeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="消息通知人员类型">
                    <el-input
                      v-model="dialogViewForm.personnelTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态">
                    <el-radio-group v-model="dialogViewForm.status">
                      <el-radio
                        :label="1"
                        disabled
                      >
                        启用
                      </el-radio>
                      <el-radio
                        :label="2"
                        disabled
                      >
                        停用
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.personnelType === 1"
                  :span="24"
                >
                  <el-form-item label="业务单据相关人员">
                    <el-input
                      v-model="dialogViewForm.businessOperator"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.personnelType === 3"
                  :span="24"
                >
                  <el-form-item label="自定义通知人员">
                    <el-input
                      v-model="dialogViewForm.userNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              消息内容模板
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      v-model="dialogViewForm.messageTemplate"
                      type="textarea"
                      :rows="10"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { initMessageNotifyPersonnelApi } from '@/api/messageNotifyPersonnel'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,

      dialogViewForm: {}
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true

        this.dialogViewForm = {}
        this.initViewData()

        this.$nextTick(() => {
          this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initViewData () {
      initMessageNotifyPersonnelApi({ id: this.dataId }).then(response => {
        const { data } = response

        this.dialogViewForm = data || {}
        this.loading = false
      })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
